var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessageIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#545563",
  d: "M20 12a8 8 0 0 1-11.008 7.415c-.178-.072-.267-.108-.339-.124a.8.8 0 0 0-.194-.022c-.074 0-.154.014-.314.04l-3.163.527c-.331.056-.497.083-.617.032a.45.45 0 0 1-.233-.233c-.051-.12-.024-.286.032-.617l.527-3.163c.026-.16.04-.24.04-.314a.8.8 0 0 0-.022-.194 2.5 2.5 0 0 0-.124-.338A8 8 0 1 1 20 12"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#545563",
  d: "M8.444 12a.444.444 0 1 1-.888 0 .444.444 0 0 1 .888 0M12.444 12a.444.444 0 1 1-.888 0 .444.444 0 0 1 .888 0M16.444 12a.444.444 0 1 1-.888 0 .444.444 0 0 1 .888 0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#545563",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M8 12h.009M12 12h.009M16 12h.009M12 20a8 8 0 1 0-7.415-4.991c.072.177.108.266.124.338.016.07.022.122.022.194 0 .074-.014.154-.04.314l-.527 3.163c-.056.331-.083.497-.032.616a.45.45 0 0 0 .234.234c.12.051.285.024.616-.032l3.163-.527c.16-.027.24-.04.314-.04a.8.8 0 0 1 .194.022c.072.016.16.052.339.124A8 8 0 0 0 12 20m-3.556-8a.444.444 0 1 1-.888 0 .444.444 0 0 1 .888 0m4 0a.444.444 0 1 1-.888 0 .444.444 0 0 1 .888 0m4 0a.444.444 0 1 1-.888 0 .444.444 0 0 1 .888 0"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M7.5 11.5h.01m4.49 0h.01m4.49 0h.01M8 11.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
})));
export default SvgMessageIcon;